function buildGdprBadges(item) {
  return [
    { key: 'lawfulBasis', value: item.lawfulBasis },
    { key: 'consentStatus', value: item.consentStatus },
    { key: 'privacyNoticeStatus', value: item.privacyNoticeStatus },
  ].filter((badge) => badge.value && badge.value !== '-');
}

export function buildLeadsTableModel(dtoList = []) {
  return dtoList.map((item) => ({
    key: item.key,
    id: item.id,
    name: item.name,
    email: item.email,
    phone: item.phone,
    country: item.country,
    language: item.language,
    status: item.status,
    collectionSource: item.collectionSource,
    collectionContext: item.collectionContext,
    lawfulBasis: item.lawfulBasis,
    consentStatus: item.consentStatus,
    marketingConsentEmail: item.marketingConsentEmail === true,
    marketingConsentPhone: item.marketingConsentPhone === true,
    privacyNoticeStatus: item.privacyNoticeStatus,
    privacyNoticeSentAt: item.privacyNoticeSentAt,
    doNotContact: item.doNotContact === true,
    assignedToId: item.assignedToId,
    assignedToName: item.assignedToName,
    isMatchedProfile: item.isMatchedProfile === true,
    matchedProfileUid: item.matchedProfileUid,
    matchedProfileName: item.matchedProfileName,
    matchedProfileEmailMasked: item.matchedProfileEmailMasked,
    matchedProfilePath: item.matchedProfilePath,
    matchedProfile: {
      isMatched: item.isMatchedProfile === true,
      uid: item.matchedProfileUid,
      name: item.matchedProfileName,
      emailMasked: item.matchedProfileEmailMasked,
      path: item.matchedProfilePath,
    },
    gdprBadges: buildGdprBadges(item),
    created: item.created,
    createdAt: item.createdAt,
    source: item.source,
  }));
}
